module.exports = __webpack_public_path__ + "img/barrage_prize_an.d279f1ad.png";